@if (journey) {
  <div class="journey-icon" [ngClass]="{'selected': selected, 'journey-icon--archived': journey.deleted}" [tooltip]="tooltip()"
    >
    @if (!isPreview) {
      <i class="remove-btn fa fa-minus-circle" aria-hidden="true"
      (click)="emitRemove()"></i>
    }
    <div class="letter-icon" [ngStyle]="{'background-color':  backgroundColor}">{{journey?.live.name[0].toUpperCase()}}</div>
    <p><b>{{journey?.live.name | ellipsis: 93 }}</b></p>
    <p>&nbsp;{{journey?.live.product_group_name}}</p>
    <div class="bottom-border" [ngStyle]="{'background-color':  backgroundColor}"></div>
  </div>
}
